import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 3 }
const _hoisted_17 = {
  class: "modal fade",
  id: "createnewUserModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "modal-dialog modal-lg" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = { class: "modal-title fs-5" }
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = { class: "col-md-12 mb-20" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "form-group mb-3" }
const _hoisted_28 = { class: "form-group mb-3" }
const _hoisted_29 = { class: "form-group mb-3" }
const _hoisted_30 = { class: "form-group mb-3" }
const _hoisted_31 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
            _createTextVNode(" Nouveau Utilisateur ", -1)
          ]))
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
          _createElementVNode("input", {
            type: "text",
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Search "
          })
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.headers,
          rows: _ctx.rows
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [12]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field == 'created_at')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
              : (props.column.field == 'name')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (props.row.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: props.row.image,
                              class: "rounded-circle me-8",
                              width: "24",
                              height: "24"
                            }, null, 8, _hoisted_9))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: require('@/assets/images/NoImage.png'),
                              class: "rounded-circle me-8",
                              width: "24",
                              height: "24"
                            }, null, 8, _hoisted_10)),
                        _createTextVNode(" " + _toDisplayString(props.row.name), 1),
                        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", _hoisted_11, _toDisplayString(props.row.email), 1)
                      ])
                    ])
                  ]))
                : (props.column.field == 'actions')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[15] || (_cache[15] = _createElementVNode("button", {
                          class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-dots" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_14, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.destroyUser(props.row))
                            }, _cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Supprimer ", -1)
                            ]), 8, _hoisted_15)
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.fetchData
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.isEditing ? "Modifier la ville" : "Nouvelle ville"), 1),
            _cache[16] || (_cache[16] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitUser && _ctx.submitUser(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_23, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de profil ", -1)),
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.imagepreview)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imagepreview,
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_25))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/images/NoImage.png'),
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_26)),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      ref: "updateImgInput",
                      type: "file",
                      accept: "image/*",
                      class: "d-none",
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                    }, null, 544),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary me-2",
                      onClick: _cache[2] || (_cache[2] = () => _ctx.updateImgInput?.click())
                    }, " Choisir la photo "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                    }, " Annuler ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { for: "name" }, "Nom Utilisateur *", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "name",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.name) = $event)),
                  placeholder: "Nom Utilisateur Complet",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.newUser.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { for: "phone" }, "Numéro Téléphone *", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "phone",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newUser.phone) = $event)),
                  placeholder: "Numéro Téléphone",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.newUser.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { for: "email" }, "Adresse électronique *", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newUser.email) = $event)),
                  placeholder: "Adresse électronique",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.newUser.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { for: "password" }, "Mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  type: "password",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newUser.password) = $event)),
                  placeholder: "Mot de passe",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.newUser.password]
                ])
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[22] || (_cache[22] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitUser && _ctx.submitUser(...args))),
              class: "btn btn-primary"
            }, _toDisplayString(_ctx.isEditing ? "Mettre à jour" : "Enregistrer"), 1)
          ])
        ])
      ])
    ])
  ], 64))
}